import {
  FormHelperText,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { map } from "lodash";
import { useMemo } from "react";
import countryList from "react-select-country-list";

export const CountryInput = (props) => {
  const {
    title,
    isRequired = false,
    errors,
    containerProps,
    ...restProps
  } = props;

  const options = useMemo(() => countryList().getData(), []);

  return (
    <Stack gap={1.25} direction={"column"} {...containerProps}>
      {title && (
        <Typography color="#415058" fontWeight={500} fontSize={".95rem"}>
          {title}
          {isRequired && "*"}
        </Typography>
      )}
      <Select
        {...restProps}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E0E2E4",
            borderRadius: ".75rem",
          },
        }}
        error={errors}
        placeholder="Country"
        displayEmpty
        renderValue={(value) => {
          if (!value) {
            return (
              <Typography color="#ABABAB" fontWeight={500}>
                Country
              </Typography>
            );
          }
          return <>{value.label}</>;
        }}
      >
        {map(options, (option) => (
          <MenuItem value={option} key={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {errors && (
        <FormHelperText error sx={{ marginTop: "-8px" }}>
          {errors.message}
        </FormHelperText>
      )}
    </Stack>
  );
};
